import { EllipsisVerticalIcon } from "@heroicons/react/24/outline";
import { Button } from "@/core/components/ui/button";
import { DropdownMenuItem } from "@/core/components/ui/dropdown-menu";
import { DropdownMenuContent } from "@/core/components/ui/dropdown-menu";
import { DropdownMenuTrigger } from "@/core/components/ui/dropdown-menu";
import { DropdownMenu } from "@/core/components/ui/dropdown-menu";
import { Skeleton } from "@/core/components/ui/skeleton";
import { Stack } from "@/core/components/ui/stack";
import { useGetAchAccount } from "@/internal-transactions/query";

interface PaymentsActionsProps {
  businessId?: string | null;
  onDeposit: () => void;
  onWithdraw: () => void;
  onAutoRefillBalance: () => void;
  onEditBankDetails: () => void;
  onAddBankDetails: () => void;
}

export const PaymentsActions = ({
  businessId,
  onDeposit,
  onWithdraw,
  onAutoRefillBalance,
  onEditBankDetails,
  onAddBankDetails,
}: PaymentsActionsProps) => {
  const { data: achAccount, isLoading } = useGetAchAccount(businessId);

  const hasAchAccount = !!achAccount;

  if (isLoading) {
    return (
      <Stack direction="row" align="center">
        <Skeleton className="h-10 w-[156px] rounded-full" />
        <Skeleton className="h-10 w-[177px] rounded-full" />
        <Skeleton className="h-10 w-10 rounded-full" />
      </Stack>
    );
  }

  if (!hasAchAccount) {
    return (
      <Stack direction="row" align="center">
        <Button size="sm" onClick={onAddBankDetails}>
          Add bank details
        </Button>
      </Stack>
    );
  }
  return (
    <Stack direction="row" align="center">
      <Button size="sm" onClick={onDeposit}>
        Deposit funds
      </Button>
      <Button size="sm" onClick={onWithdraw} variant="secondary">
        Withdraw funds
      </Button>
      <DropdownMenu>
        <DropdownMenuTrigger asChild>
          <Button variant="icon" size="icon">
            <EllipsisVerticalIcon className="h-6 w-6" />
          </Button>
        </DropdownMenuTrigger>
        <DropdownMenuContent>
          <DropdownMenuItem onClick={onAutoRefillBalance}>
            Auto-refill balance
          </DropdownMenuItem>
          <DropdownMenuItem onClick={onEditBankDetails}>
            Edit payment settings
          </DropdownMenuItem>
        </DropdownMenuContent>
      </DropdownMenu>
    </Stack>
  );
};
